import Vue from 'vue'
import Router from 'vue-router'

let tabHome = () =>import( '@/pages/home');
let index = () =>import( '@/pages/index');
let contact = () =>import( '@/pages/contact');
let loan = () =>import( '@/pages/loan');
let invest = () =>import( '@/pages/invest');
let help = () =>import( '@/pages/help');


Vue.use(Router)

var router = new Router({
  routes: [{
      path: '/',
      name: "homeTab",
      component: tabHome,
      children: [{
          path: '',
          name: 'index',
          component: index,
        },
        {
          path: '/contact',
          name: 'contact',
          component: contact,
        },
        {
          path: '/loan',
          name: 'loan',
          component: loan,          
        },
        {
          path: '/invest',
          name: 'invest',
          component: invest,          
        },
        {
          path: '/help',
          name: 'help',
          component: help,          
        },
      ]
    },
  ]
})



export default router;
